import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { toast } from "react-toastify";
import { __API_URL__ } from "../SERVER_URL";

const updateAppointment = async ({ appointmentId, data }) => {
  const token = localStorage.getItem("token");

  const updateData = {
    duration: data.duration,
    notes: data.notes,
    practitioner: data.practitioner,
    clinic: data.clinic,
    status: data.status,
    time: data.time,
    appointment_type_list: data.appointment_type_list,
    appointment_notify_push: data.notifypush,
    appointment_notify_email: data.notifyemail,
    appointment_notify_sms: data.notifysms,
  };

  const response = await axios.patch(
    `${__API_URL__}/api/appointments/update_appointment/${appointmentId}/`,
    updateData,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return response.data;
};

const useUpdateAppointmentMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateAppointment,
    onSuccess: (_data, { appointmentId }) => {
      toast.success("Appointment Updated!");
      queryClient.invalidateQueries({ queryKey: ["appointment_detail", appointmentId] });
      queryClient.invalidateQueries({ queryKey: ["patient_appointments"] });
    },
    onError: (error) => {
      console.error("Failed to update appointment:", error);
    },
  });
};

export default useUpdateAppointmentMutation;
